import { Box, Stack, Typography } from '@mui/material'
import { CarrierVisitStatus } from '@planning/app/api'
import { formatDate } from 'modules/ui/src/theme/components/table/utils/tom-table.utils'
import { CarrierVisitStatusChip } from '../CarrierVisitStatusChip'

interface Props {
  name: string
  status: CarrierVisitStatus
  isBerthed?: boolean
  number?: string | null
  date?: string | null
  isSelected?: boolean
  renderProps: any
}
export const CarrierVisitOption = (props: Props) => {
  const { name, status, isBerthed, number, date, renderProps } = props

  return (
    <Box {...renderProps} component='li' data-cy={`carrier-visit-option-${name}`}>
      <Stack flexDirection='row' gap={theme => theme.customSpacing.m}>
        <CarrierVisitStatusChip status={status} isBerthed={isBerthed} />
        {number && <Typography variant='body1'>{number}</Typography>}

        <Typography variant='body1'>{name}</Typography>

        {date && <Typography variant='body1'>{formatDate(date)}</Typography>}
      </Stack>
    </Box>
  )
}
